/**
 * Class description
 *
 * Created: 2017-12-01
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {TeslaWildCollectIndicatorView} from "../freespin/collectIndicator/TeslaWildCollectIndicatorView";
import {Tesla} from "../Tesla";
import {TeslaGameAssets} from "../TeslaGameAssets";
import {TeslaFreeSpinPostIntroAnimation} from "../freespin/transitions/TeslaFreeSpinPostIntroAnimation";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TeslaGaugeView} from "../components/animations/TeslaGaugeView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite} from "gsap";

export class TeslaReelFrameView extends BaseView {
    private _layer:ScalableLayer;
    private _reelFrame:PIXI.Container;
    private _freeSpinWildCollectIndicator:TeslaWildCollectIndicatorView;
    private _freespinIPostIntroAnimation:TeslaFreeSpinPostIntroAnimation;
    private _gaugeView:TeslaGaugeView;
    private _foregroundLayer:ScalableLayer;
    private _foregroundContainer:PIXI.Container;


    constructor(resourceGroup:ResourcesGroupName) {
        super(resourceGroup);
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.SYMBOLS_FRAME.name);
        this._layer.addChild(this);
        this._foregroundContainer = new PIXI.Container();
        this._foregroundLayer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.SYMBOLS_FRAME_FOREGROUND.name);
        this._foregroundLayer.addChild(this._foregroundContainer);
    }

    protected initAnimations():void {
        this._reelFrame = this.createReelFrame();
        this._reelFrame.name = "TeslaReelAreaView._reelFrame";

        this._freespinIPostIntroAnimation = new TeslaFreeSpinPostIntroAnimation();

        this._freeSpinWildCollectIndicator = Tesla.wildCollectIndicator;
        this._freeSpinWildCollectIndicator.position.set(324, 379);

        this._gaugeView = new TeslaGaugeView();
        this._gaugeView.position.set(-23, 360);


        this.addChild(this._reelFrame);
        this.addChild(this._freespinIPostIntroAnimation);
        this._foregroundContainer.addChild(this._freeSpinWildCollectIndicator);
        this._foregroundContainer.addChild(this._gaugeView);
    }


    protected onResize(resizeData:IResizeData):void {
        this.position.set(TeslaGameConfig.instance.REEL_AREA_POS_X, TeslaGameConfig.instance.REEL_AREA_POS_Y);
        this._foregroundContainer.position.set(TeslaGameConfig.instance.REEL_AREA_POS_X, TeslaGameConfig.instance.REEL_AREA_POS_Y);
        this._gaugeView.onResize(resizeData);
    }

    private createReelFrame():PIXI.Container {
        let container = new PIXI.Container();
        const sprite = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.REEL_FOREGROUND)[0]);
        sprite.position.set(-516, -221);
        container.addChild(sprite);
        return container;
    }

    public getFreespinPostIntroAnimation(restoreState:boolean = false):TimelineLite {
        return this._freespinIPostIntroAnimation.getFreespinPostIntroAnimation(restoreState);

    }

    public clearFreespinPostIntroAnimation():void {
        this._freespinIPostIntroAnimation.clearFreespinPostIntroAnimation();
    }

    public getGaugeAnimations(betLineWinData:IBetLineWinData[], betValue:number):TimelineLite[] {
        return this._gaugeView.getGaugeAnimations(betLineWinData, betValue);
    }

    public getNearWinGaugeAnimation(reelId:number):void {
        return this._gaugeView.getNearWinGaugeAnimation(reelId);
    }

    public resetNearWinGaugeAnimation(getCracked?:boolean):void {
        return this._gaugeView.resetNearWinGaugeAnimation(getCracked);
    }

    public resetGaugeView() {
        this._gaugeView.resetView();
    }
}